var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fb",
    d: "M74.69,0H13.31C5.96,0,0,5.96,0,13.31v61.39c0,7.35,5.96,13.31,13.31,13.31h61.39c7.35,0,13.31-5.96,13.31-13.31V13.31c0-7.35-5.96-13.31-13.31-13.31ZM59.33,22.7c-.79,0-1.58-.04-2.37,0-1.62.11-3.25.2-4.86.44-.75.11-1.48.49-2.15.87-.87.49-1.26,1.34-1.28,2.33-.06,3.1-.09,6.2-.13,9.3,0,.05.01.09.03.22.17,0,.36,0,.54,0,2.72,0,5.43-.02,8.15-.01.45,0,.89.08,1.34.11.43.03.62.21.54.68-.23,1.35-.41,2.72-.66,4.07-.38,2.09-.82,4.17-1.21,6.26-.07.37-.29.35-.55.36-2.48.02-4.95.03-7.43.05-.3,0-.6,0-.99,0v.73c0,8.81,0,17.61,0,26.42q0,.63-.62.63c-3.55,0-7.1,0-10.64,0h-.6c-.1-9.29-.21-18.55-.31-27.9h-10.18c.05-3.7.1-7.35.15-11.06h10.14c0-.34,0-.62,0-.9.02-2.94.05-5.88.07-8.82.02-2.05.32-4.05,1.02-5.97,1.3-3.59,3.93-5.68,7.56-6.63,2.83-.74,5.72-.83,8.61-.77,1.77.03,3.54.13,5.32.21.16,0,.31.03.52.04v9.35Z",
    fill: "#fff",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.62b47e3987e88839e52cb3ac5d5c15ea.svg";
export { ForwardRef as ReactComponent };